const React = require('react');

class Huangbo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appEntry: 'pc_yl',
        };
    }

    render() {
        const { imgSrc } = this.props;

        return (
            <div className="js-component-huangbo huangbo">
                <div id="js-huangbo-modal" className="huangbo-modal">
                    <div className="center">
                        <div className="part1">
                            <ul className="huangbo-swish">
                                <li className="huangbo-swish-li">
                                    <div className="huangbo-swish-img" />
                                    <div className="huangbo-text1">黄渤邀您关注微信</div>
                                    <div className="huangbo-text2">更有千元好礼等你拿！</div>
                                </li>
                            </ul>
                        </div>
                        <div className="part2">
                            <img is class="huangbo-qr" rrc-wechat-entry="2628" src={imgSrc} alt="" />
                            <div className="huangbo-qr-text">第一手的好车推荐</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = { Huangbo };
